import React from 'react';
import PropTypes from 'prop-types';

import Slack from './ChatBots/Slack';

export default function ChatBots({ channels, isLoaded }) {
  return (
    <div className="mt-4">
      <h4>Connect Your LeggUP AI Coach to Slack</h4>
      <Slack channels={channels} isLoaded={isLoaded} />
    </div>
  );
}

ChatBots.propTypes = {
  channels: PropTypes.object,
  isLoaded: PropTypes.bool.isRequired,
};

ChatBots.defaultProps = {
  channels: null,
};
